/** A video element used only to grab one frame for a clip-strip thumbnail.

Must not use preload=auto: that downloads the whole (often long) library
source in parallel with the editor Player and stalls playback. */
export function createFrameCaptureVideo(): HTMLVideoElement {
  const video = document.createElement('video');
  video.preload = 'metadata';
  video.muted = true;
  video.playsInline = true;
  return video;
}

/** Stop buffering and drop the media resource. Safe to call more than once. */
export function releaseMediaElement(el: HTMLMediaElement | null | undefined): void {
  if (!el) return;
  el.pause();
  el.removeAttribute('src');
  el.srcObject = null;
  el.load();
}
